import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    height: auto;
    flex: 1 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;
    }

    > form {
        display: flex;
        flex-direction: column;
        height: 100%;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            height: auto;
        }
    }

    .help-button {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        justify-content: flex-start;
        width: auto;
        margin-left: -1.5em;
    }

    .textInput > span {
        white-space: normal;
    }
`

export const TextFieldContainer = styled.div`
    margin-top: 1.5rem;

    span > text {
        width: 100px;
    }
`

export const PasswordCriteria = styled.div`
    margin-top: 10px;
    text-align: justify;
`
export const Container = styled.div`
    margin-top: 1rem;
    padding: 1.5rem;
    border-radius: 0.25rem;
    background: #f1f5fe;
    margin-top: 24px;
    margin-bottom: 2rem;
`

export const Title = styled.h1`
    color: #161616;
    font-size: 1rem;
    font-weight: 500;
    line-height: 150%; /* 1.5rem */
    display: flex;
    align-items: center;
    justify-content: flex-start;

    & svg {
        margin-right: 0.5rem;
    }
`

export const Text = styled.p`
    color: #666;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
    margin: 0.5rem 0;
`
